import{a as r}from"./chunk-RAAYCPUM.js";function t(...e){return r(u,e)}var u=(e,o)=>({...e,...o});export{t as a};
